import React from 'react';

function Singers (props) {
  return (
    <div>singers</div>
  )
}

export default React.memo (Singers);